<template>
  <div>
    <business-list v-show="tabType === 1" @handleShow="handleShow" />
    <business-show v-if="tabType === 2" :rowId="id" @handleShow="handleShow"/>
  </div>
</template>

<script>
import businessList from './list.vue'
import businessShow from './show.vue'
export default {
  components: { businessList,businessShow },
  data() {
    return {
      tabType: 1,
      id: null,
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType=type
      this.id = id
      console.log('id: ',id);
    }
  }
}
</script>

<style>

</style>
